export interface IShopNames {
  NameAr?: string | null;
  NameEn?: string | null;
}

// Same rule as the backend: Arabic for an Arabic UI, English otherwise, and the
// other language when the preferred one is blank.
export const getShopName = (
  names: IShopNames | undefined | null,
  languageCode: string | undefined,
): string => {
  const ar = names?.NameAr?.trim() ?? '';
  const en = names?.NameEn?.trim() ?? '';
  const isArabic = languageCode?.toLowerCase().startsWith('ar');
  return isArabic ? ar || en : en || ar;
};
